<template>
  <b-modal id="delete-project-modal" class="text-left" ref="dialog" :title="$t('project.delete.title')">
      <span v-html="$t('project.delete.text', { projectNumber } )" />
      <template slot="modal-footer">
        <b-button @click="$refs.dialog.hide()">{{ $t('project.delete.keep') }}</b-button>
        <b-button variant="danger" @click="onDeleteClick">{{ $t('project.delete.delete') }}</b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    projectNumber: {
      type: Number,
      required: false,
      default: null
    }
  },
  methods: {
    show () {
      this.$refs.dialog.show()
    },
    onDeleteClick () {
      this.$refs.dialog.hide()
      this.$emit('confirm', null)
    }
  }
}
</script>
